import { render, staticRenderFns } from "./ResponseType1.vue?vue&type=template&id=2fe1e47b&scoped=true"
import script from "./ResponseType1.vue?vue&type=script&lang=js"
export * from "./ResponseType1.vue?vue&type=script&lang=js"
import style0 from "./ResponseType1.vue?vue&type=style&index=0&id=2fe1e47b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1e47b",
  null
  
)

export default component.exports